import { z } from 'zod';

const INDUSTRIES = [
  'Retail',
  'Food & Beverage',
  'Tech',
  'Entertainment',
  'Agency',
  'Other',
] as const;
export const industries = INDUSTRIES;

export const brandProfileSchema = z.object({
  companyName: z.string().min(2, 'Company name is required'),
  contactName: z.string().min(2, 'Contact name is required'),
  industry: z.enum(INDUSTRIES, { message: 'Please pick an industry' }),
});
export type BrandProfileInput = z.infer<typeof brandProfileSchema>;

const HEX = /^#[0-9a-fA-F]{6}$/;

export const brandKitSchema = z.object({
  campaignName: z.string().min(2, 'Campaign name is required'),
  primaryColor: z.string().regex(HEX, 'Use a HEX color like #B262F5'),
  secondaryColor: z.string().regex(HEX, 'Use a HEX color like #1A1A2E'),
  font: z.string().min(1),
  clientLogo: z.string().min(1, 'Logo is required'),
  brandLogo: z.string().nullable().optional(),
  backgroundImage: z.string().nullable().optional(),
  language: z.enum(['en', 'en-es']),
  collectData: z.boolean(),
  collectName: z.boolean(),
  collectEmail: z.boolean(),
  collectPhone: z.boolean(),
  ageGate: z.enum(['none', '18+', '21+']),
  demoAge: z.boolean(),
  demoGender: z.boolean(),
  demoEthnicity: z.boolean(),
  demoNationality: z.boolean(),
  gameMechanic: z.literal('wheel'),
  celebrationTheme: z.enum(['confetti', 'fireworks', 'sparks']),
});
export type BrandKitInput = z.infer<typeof brandKitSchema>;

export const onboardingBrandKitSchema = brandKitSchema.pick({
  campaignName: true,
  primaryColor: true,
  secondaryColor: true,
  font: true,
  clientLogo: true,
});
export type OnboardingBrandKitInput = z.infer<typeof onboardingBrandKitSchema>;

export const GOOGLE_FONTS = [
  'Inter',
  'Roboto',
  'Montserrat',
  'Poppins',
  'Oswald',
  'Playfair Display',
  'Raleway',
  'Lato',
  'Open Sans',
  'Nunito',
  'Bebas Neue',
  'Archivo Black',
  'DM Sans',
  'Space Grotesk',
  'Outfit',
  'Sora',
  'Lexend',
  'Plus Jakarta Sans',
  'Urbanist',
  'Bricolage Grotesque',
] as const;
